webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(310);
	var isArguments = __webpack_require__(309);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(467);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(308);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(449);
	
	var _HelmetConstants = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(317));
	var shallowEqual = _interopDefault(__webpack_require__(484));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(57);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contentModule = __webpack_require__(318);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Content = function (_React$Component) {
	  _inherits(Content, _React$Component);
	
	  function Content(props) {
	    _classCallCheck(this, Content);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  // getRootElementFontSize() {
	  // // Returns a number
	  //   return parseFloat(
	  //     // of the computed font-size, so in px
	  //     getComputedStyle(
	  //       // for the root <html> element
	  //       document.documentElement
	  //     ).fontSize
	  //   );
	  // }
	
	  Content.prototype.render = function render() {
	    var _cx;
	
	    // var title_height = 5.5 * this.getRootElementFontSize();
	    var title_height = 5.5 * 16;
	
	    var containerclass;
	    containerclass = (0, _classnames2.default)(_contentModule2.default.container, (_cx = {}, _cx[_contentModule2.default.addpadding] = this.props.yscroll >= title_height && this.props.winwidth > 992, _cx[_contentModule2.default.consttoppadding] = this.props.winwidth <= 992, _cx));
	
	    return _react2.default.createElement(
	      "div",
	      { className: containerclass },
	      this.props.children
	    );
	  };
	
	  return Content;
	}(_react2.default.Component);
	
	exports.default = Content;
	module.exports = exports["default"];

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Content----content-module---container---3ZimT","addpadding":"src-components-Content----content-module---addpadding---2itZH","consttoppadding":"src-components-Content----content-module---consttoppadding---2vCS1"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(320);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _FooterElement = __webpack_require__(208);
	
	var _FooterElement2 = _interopRequireDefault(_FooterElement);
	
	var _email = __webpack_require__(198);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _phone = __webpack_require__(486);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _location = __webpack_require__(485);
	
	var _location2 = _interopRequireDefault(_location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _footerModule2.default.container },
	      _react2.default.createElement(
	        "div",
	        { className: _footerModule2.default.footerdiv },
	        _react2.default.createElement(
	          "div",
	          { className: _footerModule2.default.row },
	          _react2.default.createElement(
	            "div",
	            { className: _footerModule2.default.col },
	            _react2.default.createElement(
	              _FooterElement2.default,
	              { icon: _email2.default },
	              "rababw at ece dot ubc dot ca"
	            ),
	            _react2.default.createElement(
	              _FooterElement2.default,
	              { icon: _phone2.default },
	              "(604) 266-4261"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _footerModule2.default.col },
	            _react2.default.createElement(
	              _FooterElement2.default,
	              { icon: _location2.default },
	              "University of British Columbia, The Fred Kaiser Building, 5500-2332 Main Mall, Vancouver, BC, Canada, V6T 1Z4"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerelementModule = __webpack_require__(319);
	
	var _footerelementModule2 = _interopRequireDefault(_footerelementModule);
	
	var _email = __webpack_require__(198);
	
	var _email2 = _interopRequireDefault(_email);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterElement = function (_React$Component) {
	  _inherits(FooterElement, _React$Component);
	
	  function FooterElement(props) {
	    _classCallCheck(this, FooterElement);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  FooterElement.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _footerelementModule2.default.container },
	      _react2.default.createElement(
	        "div",
	        { className: _footerelementModule2.default.row },
	        _react2.default.createElement(
	          "div",
	          { className: _footerelementModule2.default.col1 },
	          _react2.default.createElement("img", { className: _footerelementModule2.default.icon, src: this.props.icon })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _footerelementModule2.default.col2 },
	          _react2.default.createElement(
	            "p",
	            null,
	            this.props.children
	          )
	        )
	      )
	    );
	  };
	
	  return FooterElement;
	}(_react2.default.Component);
	
	exports.default = FooterElement;
	module.exports = exports["default"];

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Footer-FooterElement----footerelement-module---container---32XRF","row":"src-components-Footer-FooterElement----footerelement-module---row---1jSbU","col1":"src-components-Footer-FooterElement----footerelement-module---col1---1Lsun","col2":"src-components-Footer-FooterElement----footerelement-module---col2---Gj2oo","icon":"src-components-Footer-FooterElement----footerelement-module---icon---6b-U-"};

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Footer----footer-module---container---Xg_8o","footerdiv":"src-components-Footer----footer-module---footerdiv---120Ju","row":"src-components-Footer----footer-module---row---xjUv1","col":"src-components-Footer----footer-module---col---3uBDB"};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerModule = __webpack_require__(327);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _NavTitle = __webpack_require__(131);
	
	var _NavTitle2 = _interopRequireDefault(_NavTitle);
	
	var _NavTitleLink = __webpack_require__(213);
	
	var _NavTitleLink2 = _interopRequireDefault(_NavTitleLink);
	
	var _NavSlide = __webpack_require__(211);
	
	var _NavSlide2 = _interopRequireDefault(_NavSlide);
	
	var _NavSlideLink = __webpack_require__(212);
	
	var _NavSlideLink2 = _interopRequireDefault(_NavSlideLink);
	
	var _Title = __webpack_require__(214);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _headerModule2.default.container },
	      _react2.default.createElement(
	        "div",
	        { className: _headerModule2.default.navslide_container },
	        _react2.default.createElement(
	          _NavSlide2.default,
	          null,
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/" },
	            "Home"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/biography" },
	            "Biography"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/recognition" },
	            "Recognition"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/activities" },
	            "Professional Activities"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/publications" },
	            "Publications"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/research" },
	            "Research"
	          ),
	          _react2.default.createElement(
	            _NavSlideLink2.default,
	            { to: "/students" },
	            "Mentoring and Students"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _headerModule2.default.navtitle_container },
	        _react2.default.createElement(_Title2.default, null),
	        _react2.default.createElement(
	          _NavTitle2.default,
	          { yscroll: this.props.yscroll },
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/" },
	            "Home"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/biography" },
	            "Biography"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/recognition" },
	            "Recognition"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/activities" },
	            "Professional Activities"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/publications" },
	            "Publications"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/research" },
	            "Research"
	          ),
	          _react2.default.createElement(
	            _NavTitleLink2.default,
	            { to: "/students" },
	            "Mentoring and Students"
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menubuttonModule = __webpack_require__(321);
	
	var _menubuttonModule2 = _interopRequireDefault(_menubuttonModule);
	
	var _classnames = __webpack_require__(57);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButton = function (_React$Component) {
	  _inherits(MenuButton, _React$Component);
	
	  function MenuButton(props) {
	    _classCallCheck(this, MenuButton);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  MenuButton.prototype.render = function render() {
	    var _cx;
	
	    // var containerClasses=["container"];
	    // if (!this.props.state){
	    //   containerClasses.push("close")
	    // }
	    var className = (0, _classnames2.default)(_menubuttonModule2.default.container, (_cx = {}, _cx[_menubuttonModule2.default.close] = !this.props.state, _cx));
	
	    return _react2.default.createElement(
	      "span",
	      { className: className },
	      _react2.default.createElement("div", { className: _menubuttonModule2.default.bar1 }),
	      _react2.default.createElement("div", { className: _menubuttonModule2.default.bar2 }),
	      _react2.default.createElement("div", { className: _menubuttonModule2.default.bar3 })
	    );
	  };
	
	  return MenuButton;
	}(_react2.default.Component);
	
	exports.default = MenuButton;
	module.exports = exports["default"];

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar1":"src-components-Header-MenuButton----menubutton-module---bar1---WE7as","bar2":"src-components-Header-MenuButton----menubutton-module---bar2---T11dJ","bar3":"src-components-Header-MenuButton----menubutton-module---bar3---3YHmN","container":"src-components-Header-MenuButton----menubutton-module---container---1xBN2","close":"src-components-Header-MenuButton----menubutton-module---close---M_80v"};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navslideModule = __webpack_require__(322);
	
	var _navslideModule2 = _interopRequireDefault(_navslideModule);
	
	var _classnames = __webpack_require__(57);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MenuButton = __webpack_require__(210);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _UBCLogoWhite = __webpack_require__(197);
	
	var _UBCLogoWhite2 = _interopRequireDefault(_UBCLogoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavSlide = function (_React$Component) {
	  _inherits(NavSlide, _React$Component);
	
	  function NavSlide(props) {
	    _classCallCheck(this, NavSlide);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.ChangeNav = function () {
	      _this.setState(function (prevState) {
	        return { open: !prevState.open };
	      });
	    };
	
	    _this.state = { open: false };
	    return _this;
	  }
	
	  NavSlide.prototype.render = function render() {
	    var _cx,
	        _cx2,
	        _this2 = this;
	
	    // var containerClasses=["sidenav_container"];
	    // if (this.state.open){
	    //   containerClasses.push("open")
	    // }
	
	    var sidenav_container1 = (0, _classnames2.default)(_navslideModule2.default.sidenav_container1, (_cx = {}, _cx[_navslideModule2.default.sidenav_container1_disp] = this.state.open, _cx));
	
	    var sidenav_container2 = (0, _classnames2.default)(_navslideModule2.default.sidenav_container2, (_cx2 = {}, _cx2[_navslideModule2.default.open] = this.state.open, _cx2));
	
	    var w;
	    if (this.state.open) {
	      w = "100%";
	    } else {
	      w = "0";
	    }
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: _navslideModule2.default.navbar },
	        _react2.default.createElement(
	          "div",
	          { className: _navslideModule2.default.logocontainer },
	          _react2.default.createElement("img", { className: _navslideModule2.default.logo, src: _UBCLogoWhite2.default })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _navslideModule2.default.title },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "Rabab Kreidieh Ward"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Professor Emeritus, Electrical and Computer Engineering"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _navslideModule2.default.menubutton, onClick: function onClick() {
	              return _this2.ChangeNav();
	            } },
	          _react2.default.createElement(_MenuButton2.default, { state: !this.state.open })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _navslideModule2.default.sidenav, style: { width: w }, onClick: function onClick() {
	            return _this2.ChangeNav();
	          } },
	        this.props.children
	      )
	    );
	  };
	
	  return NavSlide;
	}(_react2.default.Component);
	
	exports.default = NavSlide;
	module.exports = exports["default"];

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sidenav_container1":"src-components-Header-NavSlide----navslide-module---sidenav_container1---1_2GO","sidenav_container1_disp":"src-components-Header-NavSlide----navslide-module---sidenav_container1_disp---2PR3I","sidenav_container2":"src-components-Header-NavSlide----navslide-module---sidenav_container2---12mpD","sidenav":"src-components-Header-NavSlide----navslide-module---sidenav---3okNR","open":"src-components-Header-NavSlide----navslide-module---open---2zfK6","menubutton":"src-components-Header-NavSlide----navslide-module---menubutton---3eYwP","title":"src-components-Header-NavSlide----navslide-module---title---7q6K3","logo":"src-components-Header-NavSlide----navslide-module---logo---260Sa","logocontainer":"src-components-Header-NavSlide----navslide-module---logocontainer---3yYwU","navbar":"src-components-Header-NavSlide----navslide-module---navbar---1mnf9"};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navslidelinkModule = __webpack_require__(323);
	
	var _navslidelinkModule2 = _interopRequireDefault(_navslidelinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavSlideLink = function (_React$Component) {
	  _inherits(NavSlideLink, _React$Component);
	
	  function NavSlideLink(props) {
	    _classCallCheck(this, NavSlideLink);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  NavSlideLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _navslidelinkModule2.default.container },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: this.props.to },
	        _react2.default.createElement(
	          'h5',
	          { className: _navslidelinkModule2.default.link },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return NavSlideLink;
	}(_react2.default.Component);
	
	exports.default = NavSlideLink;
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header-NavSlideLink----navslidelink-module---container---3hB4v","link":"src-components-Header-NavSlideLink----navslidelink-module---link---2lDYl"};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navtitleModule = __webpack_require__(324);
	
	var _navtitleModule2 = _interopRequireDefault(_navtitleModule);
	
	var _classnames = __webpack_require__(57);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavTitle = function (_React$Component) {
	  _inherits(NavTitle, _React$Component);
	
	  function NavTitle(props) {
	    _classCallCheck(this, NavTitle);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  NavTitle.prototype.render = function render() {
	    var _cx;
	
	    // var title_height = 5.5 * this.getRootElementFontSize();
	    var title_height = 5.5 * 16;
	
	    var navbarclass = (0, _classnames2.default)(_navtitleModule2.default.navcontainer, (_cx = {}, _cx[_navtitleModule2.default.sticky] = this.props.yscroll >= title_height, _cx));
	
	    return _react2.default.createElement(
	      "div",
	      { className: _navtitleModule2.default.container },
	      _react2.default.createElement(
	        "div",
	        { className: navbarclass },
	        _react2.default.createElement(
	          "div",
	          { className: _navtitleModule2.default.navdiv },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return NavTitle;
	}(_react2.default.Component);
	
	exports.default = NavTitle;
	module.exports = exports["default"];

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header-NavTitle----navtitle-module---container---1r4F6","navcontainer":"src-components-Header-NavTitle----navtitle-module---navcontainer---GGtIA","navdiv":"src-components-Header-NavTitle----navtitle-module---navdiv---2rUmh","sticky":"src-components-Header-NavTitle----navtitle-module---sticky---1JnZK"};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navtitlelinkModule = __webpack_require__(325);
	
	var _navtitlelinkModule2 = _interopRequireDefault(_navtitlelinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavTitleLink = function (_React$Component) {
	  _inherits(NavTitleLink, _React$Component);
	
	  function NavTitleLink(props) {
	    _classCallCheck(this, NavTitleLink);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    // this.state = {active: false, change: false};
	  }
	
	  NavTitleLink.prototype.render = function render() {
	    // if (this.props.active && this.props.change){
	    //   this.setState({})
	    // }
	    return _react2.default.createElement(
	      'div',
	      { className: _navtitlelinkModule2.default.container },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: this.props.to },
	        _react2.default.createElement(
	          'div',
	          { className: _navtitlelinkModule2.default.innercontainer },
	          _react2.default.createElement(
	            'p',
	            { className: _navtitlelinkModule2.default.link },
	            this.props.children
	          )
	        )
	      )
	    );
	  };
	
	  return NavTitleLink;
	}(_react2.default.Component);
	
	exports.default = NavTitleLink;
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header-NavTitleLink----navtitlelink-module---container---31ab6","link":"src-components-Header-NavTitleLink----navtitlelink-module---link---p_Ria","innercontainer":"src-components-Header-NavTitleLink----navtitlelink-module---innercontainer---3fNHD"};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _titleModule = __webpack_require__(326);
	
	var _titleModule2 = _interopRequireDefault(_titleModule);
	
	var _UBCLogoWhite = __webpack_require__(197);
	
	var _UBCLogoWhite2 = _interopRequireDefault(_UBCLogoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Title = function (_React$Component) {
	  _inherits(Title, _React$Component);
	
	  function Title(props) {
	    _classCallCheck(this, Title);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Title.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _titleModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _titleModule2.default.titlediv },
	        _react2.default.createElement(
	          'div',
	          { className: _titleModule2.default.namecontainer },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Rabab Kreidieh Ward'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _titleModule2.default.sub },
	              'Professor Emeritus, Electrical and Computer Engineering'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _titleModule2.default.logocontainer },
	          _react2.default.createElement('img', { className: _titleModule2.default.logo, src: _UBCLogoWhite2.default })
	        )
	      )
	    );
	  };
	
	  return Title;
	}(_react2.default.Component);
	
	exports.default = Title;
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header-Title----title-module---container---w0N-_","titlediv":"src-components-Header-Title----title-module---titlediv---1KMk-","namecontainer":"src-components-Header-Title----title-module---namecontainer---1g1sD","sub":"src-components-Header-Title----title-module---sub---vgyhP","logocontainer":"src-components-Header-Title----title-module---logocontainer---Vn8M2","logo":"src-components-Header-Title----title-module---logo---3LJNn"};

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header----header-module---container---TXsPj","navtitle_container":"src-components-Header----header-module---navtitle_container---1xwpa","navslide_container":"src-components-Header----header-module---navslide_container---2CtQF"};

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAACHCAYAAAAC7ucBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ1dWlkOjVEMjA4OTI0OTNCRkRCMTE5MTRBODU5MEQzMTUwOEM4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkJCOEFERUFFMjA2MDExRTY4QTg3RjlBNkZBMjI3QjY2IiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkJCOEFERUFEMjA2MDExRTY4QTg3RjlBNkZBMjI3QjY2IiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIElsbHVzdHJhdG9yIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZDVkYTUwZDctNTU0OC00MjQ1LThhZDctNDYwMzdmNzdkOTdkIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmQ1ZGE1MGQ3LTU1NDgtNDI0NS04YWQ3LTQ2MDM3Zjc3ZDk3ZCIvPiA8ZGM6dGl0bGU+IDxyZGY6QWx0PiA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPuKAojRfMjAxNl9sb2dvX21hc3RlclJHQjwvcmRmOmxpPiA8L3JkZjpBbHQ+IDwvZGM6dGl0bGU+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+o0NmzAAADM5JREFUeNrsXf2Vm7oSZ3Py/6OD5VYQUsGSCh63gpAKllRwSQUkFeBbgfdVgFOBvRXgWwFOBTx07rCRtRppRpK92GbO4WwcY/Tx03zop5G4G0aJFpmFvFu6YAFjEY28Vz4fxmu3dMvZJB2v+OXTcCzt0j/nE9HfcucvZmrxGYssYFyYA8ds27GjkeTu7m7DtJOsZ433J+OfhFMGt07MumfjdQ/OVxUR/PwzXpuxDjuXAqwOXHU0svg6Lduzxv+uBjfpxqsGMH0ASKAOXejyb8mBi04ox0t0SjNesQMQ1fhnO15/cbVTKT8NZqauQAphVsZO+TSajwMBBAFci5iixYEHmmDVFLME2hAMCKr/uHTN+Cb9+wECA1MnFmNnfxs7Z2/QiDXRJO3hmiQ2OPXo6sEYO7VCRvbaAEo+Xt+R7/4iaIQYACsdoACmeP5niLoiBbDbMlPQSX8abokNYWtp0YSPYgBgmiX80XgJoD6NHz/Bb55vQjNMgIydu2Pa/UfDd8Lpf8JAwOY6Yx0+Bp/0XbDDpoawMURcmHzlACFrys1HU2KyZfj6CfEjqHkSpmc2dMiFAJBCFPQoOU9VMJriAxO8BQwdlcO4fWdw7CaT9nOZ9IWVFTjgg8NvDwsYYSW3OOjEFBUtYIQVES3VwJLGnNHvQjDeqgOX6ZB7GOGZ4X7xXaPxHQdLiLxZwHCgQ2A0l0Bt6EZ1Pn6fMcxPcjFmykGN4zOAJLinL4ZbPjMipv9eks9IT3y/KyBifrAnjnYTs5r7rhaGBmMXYuSMjcody3CVPQM4k9+o5wSGiXksGKbKRMadwklytPDJoh2liwm3UDOvZ7GEhITYsvi+tQEC69AmyZDfVS7JEJby1pr7E0KSAWktHfpL1LuH32G0/VFCAjm9k9CZPVQgk/kiMaIImRWmcslgQIcWpgwUkIJbltJOMWc58iWi3VD2mjHQnMFIJKRDS+oChmsKj2VUtydoX0kpixxNAZ//5QR2/YtTwpebHCLzKmAE34euz33w0Baiji+BgVidEYhPNuBh6VSs0H0/dyDBnmdA5330jH7Ebz+eCYgD0CZ/cDRwvPdr9O86tm+UtyIPYJ/9GeC0GqIv6eHejFkG12e0cFWWeY1LOztGHUpChHnkM+6UqGQDmQ0uFU5gZisnNk87ofYua8hzFKmdiTSTn9p54GgfDP4siGYs4g3ssnNprvI+oOpmoLYfotfMrN++heOyUjCFoqwHzS0/gZPaBSori/T7MQ5AE+2hXfsQHelkpmDKXwAVwpHJkXPymnz2SFQc1hVYg8ZhgruF/ohdzRTLgUMklABTGyJSEaPpbwgfX5w8NGjSgM9RGNp9B2XtQGsOikPOoF0hyhLzsf9BmzZUB04C45XXX4Q9r6L06+LAZyQLGAsYi5wqtD2Aw/qJhZOSQ/Z1knulrD0SZqcQ9uaRe3bHDpzwRnb4SJg9leWXbOGx9XiNLdIQQ9X6lJyWB3/mvF3ZsLhE6ldqNFUD6v/AiNk45q1iE6spTH6QRuUvKGcTkH7IQDv/I2nnlKbzFGpdBSxBBmXcA2f19Sa4KdivffHc1PuAD5ZpCm2sjdlexxEuP+te9U8hNErxdZi/3AXTXs/1jNyBOthSuH6CPY7lNig0jbNfg9+XTJpn8mu5j2awwQCHWDvwRAMWBOgcJnQKCram82NkgB11lm4QSFkl6xAJD9A/2UnAOFHGhI+0yuAYlBSh2dbX1K+XOumT/U6i/FW/X2bgJ5ZnCxjPCxjnE3nm/UH5q35/U3SISh0cLcpL4WESiDZ4io7TZ2Ll7xRGP0V+ay4yzbNXw3LpRDlfiicIHdJBCJgQy0mneyGqWYdYRbPk3rqsRq6nEBWirJTYvsSQVxycDkmj3+u+TtSBKFx+vnQKzQfNyNpLZe1Ng2n693jfnamzpLISjWZPZR2w+jpQPFM+wG52dAiM0Dzg8zJKtrfjs4X2bi+VDpF9Q6Jo20ay5WJCFIpojC2ffdpSR9IGGolklDV3H4riCUGHTFkbW8rGFBhtgwuxBz6nlukNTepnpdAnNScLRfPcXPq/tcWnsbJQQtEh1A0pL1SE8ttJEiIAqlMspe/VDTyN9F2pCTZSYvte1ZHBv7UYxRPETEkOPHUwBSKiSYQThkO59mDGRMfJznytPDszhNGRZqKnflbvq6GcSAmNRSgu79mYAJVThxJGu1/M2fi7KQdX68BDhrYcKZDRnCtmhbXLSTNae0WruHXLES0rrombekCoinqaO8BeDeu6gBJSow6cGHpvpj0iktPW1fPhmuiQVJkdy+ZD3u9mU+W9EstjMT6VFpHLK9UoEKn/7OmQPVT+OdLvh0vkEQu2dBrFj+PnFfgU8d33CD9Fc08IY2PlfsyRfp+0B3zCo+JH5Hb8QIBNYWKXRSHOGPHwGc5ZG5rnrRUKo7dlbRh2NFVKZFQjz4sNYWvr0CZTFgqpX7lgtFAgK9vaEMdrZ8/gSNtpvzUW4SFg1IYZ9XTmVG6YxTvNgzR8WCP3mwsY23PYRqQDOk/tcp24dtRN9Ceih1AwBubDclcNsZkYx05kgYqZOg+NyH36wBeMlHJuCGVUSLY88QCT3AbDiQ9bRyC2XOpFLdgrtJUijtYBkA0SCVFfq+D8/TTHQSKyDReI6N93bUTeGYkBXttTSGRZyjRxrBN2LD4n1O9zB8swuOQdBzVTGlqiZ66MuR62UrocnELwN8PAW7nsVRrmzcyUJCvJzLQUQICEw2bIicWZ20xibHLahgka6fAAaF8rlbMKFV71vmGdZpSTNMRyhhXqzAnEZct02q/IQaJGsLTJYir7d1GA43xgNG2UkUnRkGfL6K4Da0Zt+e0zUyMmsnEfQC92ulFWOGpYjozu1DLKBq4zpnDWDk5/INS193H4SODzW5s1tIIPFdBxjqFDzKTRmRPOSxx05wISErV7Rsc5sQaWCWctzNQv5b57D1X7G/n/xgCIzUyqzpwaPqdEp22sB9S7YbaXImo//9L5DB8q2BRVYIBQ3k/xKDlJav0ShB7H5CcTCN8oKtH5jNSmruAPqPMH2ymfhYMtf6HZGYeBVQg9TvJNhKXWhtgfqc6voP7KNvGR7HRJKJzSuQXXIU8dxujcNQPogQkEaQogTU5j24TXRNrpkFxLjbQd99ZRR66BNMR2BVGTI1rG7qotYdGKwxDEcn8RIs+tybRUlgd0ljCQmk3RWBaKziU10cRSosNUGQQ5IZJqTFxPSwxDS8PIoCZ9NRbS8BySM4DoB/w47ZISLmu0uzROvhhLnS2Sqt8wOuOt9+Bxym+QwdcyloDNk03NSM4ZTGuviUbS4Tol1QQsPZUB1liBF+15Z1hUeSBwUCoXVSkLT5voumSj7MqqNFyVjbN6sC5maZxu57AodGS2AqRFzk0Ki1myclaaCK/AnC6JOKPwPJPZGk73ZoFzS08wS7aBnJo4tHeSWTloqJHPiLp+I1DYk9laXYmJWlnMEqV/1P7EN9pozEofIHTtrkQzqO0whb69yUSpy67qe4dinU0DNH84EmKXKtR2/EBObSs0GvWEggEPWRFNlUhQPkSLyHKI8PduqP24UkF7R+DoM50jZ2rHrcgPw1mGmdNaiMY+Ngbf0Q2LTD4lJi4r0FcIkflB4kkKXrsUSP8kHKLRSzsQ4uvWhPNKPf66OTLiM48sj2uWlLHQ5pR9o9MOp5cbXrlUDIvhnE2CaUdpuH97Y0BsCUuu/lphQNc0wzzlWy5nx1UZghodQ+F/SA7iD0zmKr8RMHJmQBNm+zLiD0qmil6TcNteBZ1aIv4g9cifulRpmFYk/KZVpCB01nmlgDSW9JzuZOaJqILbGwHEBsSWY85CAdJwKnolgDSh+yQUGNgoaBzmLBfLOVmAcNqO7QNI7wAIZf14TvOIzAGI/mxAKA7dBRBKZsWbE3+DPZ8YAyKN3kJMgBAaU85QS/rBvm05nh0QBEC2BECSGWlJO9hPXsD85dsDQQCkG2hbkPPh7VYMu4G21yJF6jgfIAiAkONtiLj6M5qkgliv0vCMeQFBUGMha0qUAc+oTqgpHTyfWhdsp9T27FGTIyBrw0jiHJRSBASl46wngOnsfQbWnEAxMbfrgffCdO4rHtSyOAMgsZRVRpcoBqc3aUnFfF5CNGGTKUqYz68M2tDN1j8wzVYdynwo2tIMx8crNYPD8REEc1hflFkiNDizNNgVlBieHZ8ABFLYe8laUoV0tB6JFjZTV12VNng4ycnsOL8OGimT8trrdagyL9F0tcSIqPDQAkok1l6tSToRKCQnPfBeALyAYAiFGwad0cDITwb+G5ibiw9Vz+hTTkGJOM0/FnltcrzWsIeAr6RbQPl9+j7niKPiJsLTGWlMJ5mgi9aA/wswAFQZhK+DPepRAAAAAElFTkSuQmCC"

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjIgNXYxNGgtMjB2LTE0aDIwem0yLTJoLTI0djE4aDI0di0xOHptLTIgMTZsLTYuNTI2LTYuNjE4LTMuNDQ1IDMuNDgzLTMuNDE4LTMuNTI1LTYuNjExIDYuNjYgNS4wNTEtOC01LjA1MS02IDEwLjAyOSA3LjQ0NiA5Ljk3MS03LjQ0Ni00Ljk5OCA2LjAxIDQuOTk4IDcuOTl6Ii8+PC9zdmc+"

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgM2MyLjEzMSAwIDQgMS43MyA0IDMuNzAyIDAgMi4wNS0xLjcxNCA0Ljk0MS00IDguNTYxLTIuMjg2LTMuNjItNC02LjUxMS00LTguNTYxIDAtMS45NzIgMS44NjktMy43MDIgNC0zLjcwMnptMC0yYy0zLjE0OCAwLTYgMi41NTMtNiA1LjcwMiAwIDMuMTQ4IDIuNjAyIDYuOTA3IDYgMTIuMjk4IDMuMzk4LTUuMzkxIDYtOS4xNSA2LTEyLjI5OCAwLTMuMTQ5LTIuODUxLTUuNzAyLTYtNS43MDJ6bTAgOGMtMS4xMDUgMC0yLS44OTUtMi0ycy44OTUtMiAyLTIgMiAuODk1IDIgMi0uODk1IDItMiAyem0xMiAxNGgtMjRsNC04aDMuMTM1Yy4zODUuNjQxLjc5OCAxLjMwOSAxLjIzMiAyaC0zLjEzMWwtMiA0aDE3LjUyN2wtMi00aC0zLjEzMWMuNDM1LS42OTEuODQ4LTEuMzU5IDEuMjMyLTJoMy4xMzZsNCA4eiIvPjwvc3ZnPg=="

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNi4xNzYgMS4zMjJsMi44NDQtMS4zMjIgNC4wNDEgNy44OS0yLjcyNCAxLjM0MWMtLjUzOCAxLjI1OSAyLjE1OSA2LjI4OSAzLjI5NyA2LjM3Mi4wOS0uMDU4IDIuNjcxLTEuMzI4IDIuNjcxLTEuMzI4bDQuMTEgNy45MzJzLTIuNzY0IDEuMzU0LTIuODU0IDEuMzk2Yy03Ljg2MiAzLjU5MS0xOS4xMDMtMTguMjU4LTExLjM4NS0yMi4yODF6bTEuOTI5IDEuMjc0bC0xLjAyMy41MDRjLTUuMjk0IDIuNzYyIDQuMTc3IDIxLjE4NSA5LjY0OCAxOC42ODZsLjk3MS0uNDc0LTIuMjcxLTQuMzgzLTEuMDI2LjVjLTMuMTYzIDEuNTQ3LTguMjYyLTguMjE5LTUuMDU1LTkuOTM4bDEuMDA3LS40OTctMi4yNTEtNC4zOTh6Ii8+PC9zdmc+"

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(448);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(334);
	
	var _Header = __webpack_require__(209);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _NavTitle = __webpack_require__(131);
	
	var _NavTitle2 = _interopRequireDefault(_NavTitle);
	
	var _Content = __webpack_require__(206);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Footer = __webpack_require__(207);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import Transition from "../components/Transition/MyTransition"
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout(props) {
	    _classCallCheck(this, MainLayout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateYscroll = function () {
	      if (typeof window !== 'undefined') {
	        var w = window;
	        // var w = this.state.Window
	        var y = w.scrollY;
	        _this.setState({ Yscroll: y });
	      }
	    };
	
	    _this.updateDimensions = function () {
	      if (typeof window !== 'undefined') {
	        var w = window;
	        // var w = this.state.Window
	        var width = w.innerWidth;
	        var height = w.innerHeight;
	        _this.setState({ Width: width, Height: height });
	      }
	    };
	
	    _this.state = { Window: 0, Yscroll: 0, Width: 0, Height: 0 };
	    return _this;
	  }
	
	  MainLayout.prototype.componentWillMount = function componentWillMount() {
	    // this.setState({Window: window})
	    this.updateDimensions();
	  };
	
	  MainLayout.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener("scroll", this.updateYscroll);
	    window.addEventListener("resize", this.updateDimensions);
	  };
	
	  MainLayout.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("scroll", this.updateYscroll);
	    window.removeEventListener("resize", this.updateDimensions);
	  };
	
	  MainLayout.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: 'Rabab Kreidieh Ward',
	          meta: [{ name: 'description', content: 'Professor Emeritus, Electrical and Computer Engineering' }, { name: 'keywords', content: 'Professor, UBC, Image Processing, Signal Processing' }]
	
	        },
	        _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Noto+Sans|Noto+Serif', rel: 'stylesheet' })
	      ),
	      _react2.default.createElement(_Header2.default, { yscroll: this.state.Yscroll, winwidth: this.state.Width }),
	      _react2.default.createElement(
	        _Content2.default,
	        { yscroll: this.state.Yscroll, winwidth: this.state.Width },
	        this.props.children()
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	;
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = MainLayout;
	
	// export const query = graphql`
	//   query LayoutQuery {
	//     site {
	//       siteMetadata {
	//         title
	//       }
	//     }
	//   }
	// `
	
	// <Search/>
	// <Warning content="The deadline for regular and special session papers has been extended to April 25"/>
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8aebc342308d5c1b41a6.js